import { useTranslationInternal } from '../core/TranslationProvider';

/**
 * Hook para gestionar el idioma actual
 * Uso: const { currentLanguage, languages, setLanguage } = useLanguage();
 *
 * `refreshTranslations` permite forzar la recarga del catálogo desde el backend
 * (por ejemplo tras publicar traducciones nuevas) sin recargar la página.
 */
export const useLanguage = () => {
  const { currentLanguage, languages, setLanguage, isReady, refreshTranslations } =
    useTranslationInternal();

  return {
    currentLanguage,
    languages,
    setLanguage,
    isLanguageChanging: !isReady,
    refreshTranslations,
  };
};
